import axios from "axios";
import Config from "./config";
import authHeader from "./authHeader";
import { isEmpty } from "lodash";

const getAIInterviewDetails = (nId) => {
  return axios.get(
    `${Config.API_URL}api/v1/interview/get-ai-interview-review-details/${nId}/`,
    {
      headers: authHeader(),
    }
  );
};

const getAiCandidateAssessments = (params) => {
  return axios.get(
    `${Config.API_URL}api/v1/interview/dynamic-interview-candidate-assessment/`,
    {
      params,
      headers: authHeader(),
    }
  );
};

const getAiCandidateAssessmentAnswers = (params) => {
  return axios.get(
    `${Config.API_URL}api/v1/interview/dynamic-interview-questionanswers/`,
    {
      params,
      headers: authHeader(),
    }
  );
};

const getInterviewTypes = (params) => {
  return axios.get(
    `${Config.API_URL}api/v1/subscriptions/mock-interview-payment-list/`,
    {
      params,
      headers: authHeader(),
    }
  );
};

const getInitialtePayment = (data, params) => {
  const config = {
    headers: authHeader(),
  };
  if (!isEmpty(params)) {
    config["params"] = params;
  }
  return axios.post(
    Config.API_URL + "api/v1/subscriptions/initiate-phonepe-payment/",
    data,
    config
  );
};

const getScheduleInterview = (data, params) => {
  const config = {
    headers: authHeader(),
  };
  if (!isEmpty(params)) {
    config["params"] = params;
  }
  return axios.post(
    Config.API_URL + "api/v1/interview/send-resume-assessment/",
    data,
    config
  );
};

const getPersonalityInterviewReport = (id) => {
  return axios.get(
    Config.API_URL +
      `api/v1/interview/personality-report/${id !== "" ? `${id}/` : ""}`,
    {
      headers: authHeader(),
    }
  );
};

const getAssessmentList = () => {
  return axios.get(
    Config.API_URL +
      `api/v1/subscriptions/candidate-completed-interview-list/`,
    {
      headers: authHeader(),
    }
  );
};

const getDreamRoleData = (params) => {
  return axios.get(
    `${Config.API_URL}api/v1/jobs/hidden-job-listing/`,
    {
      params,
      headers: authHeader(),
    }
  );
};

const AssesmentService = {
  getAIInterviewDetails,
  getAiCandidateAssessments,
  getAiCandidateAssessmentAnswers,
  getInterviewTypes,
  getInitialtePayment,
  getScheduleInterview,
  getPersonalityInterviewReport,
  getAssessmentList,
  getDreamRoleData
};

export default AssesmentService;
